(ns app.front.view.profile.mfa
  (:require [app.front.ui :as ui]
            [app.front.util :refer [for-frag]]
            [app.front.view.profile.subs :as profile-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [>evt]]
            [core.front.icons :as i]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::disable-mfa
  (fn [_ [_ mfa-config-id user-id]]
    {:comm/command {:command    :group/set-user-mfa-status
                    :data       {:mfa-config/id mfa-config-id
                                 :user-id       user-id
                                 :enabled?      false}
                    :on-success [::disable-mfa.success]}}))


(rf/reg-event-db ::disable-mfa.success
  (fn [db _]
    (p/dissoc-in db [::profile-subs/form-data :user/mfa-config])))


(rf/reg-event-fx ::enable-mfa
  (fn [_ [_ mfa-config]]
    {:comm/command {:command    :user/enable-group-mfa
                    :data       (select-keys mfa-config [:mfa-config/id])
                    :on-success [::enable-mfa.success]}}))


(rf/reg-event-fx ::enable-mfa.success
  (fn [_ [_ _ {:keys [mfa]}]]
    (when-let [mfa-url (:redirect-url mfa)]
      {:navigate-to mfa-url})))


(defn current-mfa-config [tr {:mfa-config/keys [display-name users-can-disable? id]} user-id]
  [:div.flex.items-center
   (tr [:profile/current-mfa]
       [display-name])
   (when users-can-disable?
     [ui/modal-confirmation-button {:tr                  tr
                                    :modal-title         (tr [:user-management/disable-mfa]
                                                             [display-name])
                                    :trigger-button-text (tr [:user-management/disable-mfa]
                                                             [display-name])
                                    :trigger-button-opts {:size       :small
                                                          :kind       :tertiary
                                                          :icon       i/lock-open
                                                          :class-name "ml-3"}
                                    :on-yes-click        #(>evt [::disable-mfa id user-id])}
      (tr [:profile/disable-mfa-modal])])])


(defn mfa-config-list [tr mfa-configs]
  (let [multiple? (> (count mfa-configs) 1)]
    [:div.flex.flex-col.gap-y-4
     [:h4 (tr [:profile/mfa-heading])]
     (when multiple?
       [:div (tr [:profile/mfa-multiple-guide])])
     (for-frag [config mfa-configs]
       [:div
        (when multiple?
          [:h5.mb-2 (-> config :mfa-config/group :group/name)])
        (cc/button {:size     :small
                    :kind     :tertiary
                    :icon     i/lock
                    :on-click #(>evt [::enable-mfa config])}
                   (tr [:user-management/enable-mfa]
                       [(:mfa-config/display-name config)]))])]))
